import gsap from 'gsap';
import videoInit from './components/video';
import carousel from './components/carousel'
import blogHeight, {backLink} from './components/blogHeight';
import faq from './components/faq';
import {navigationInit} from './components/navigation';
import formInit from './components/formInit';

import parallax, {scrollRefresh} from './components/parallax'
import mapInteractive from './components/map'
import heroCarousel from './components/heroCarousel'
import retirementVideo from './components/retirement_video'
import popup from './components/popup'


window.onload = function(){
     window.scrollTo(0, 0);
     heroCarousel();
     videoInit();
     carousel();
     faq();
     navigationInit();
     formInit();
     backLink();
     parallax();
     mapInteractive();
     scrollRefresh();
     retirementVideo();
     popup();
     
     const preload = document.querySelector('.preload')
     const introTl = gsap.timeline();
     introTl
          .to(preload, {duration: 1.5, 
          opacity:0, ease:'power4.inOut', onComplete:()=> {
          preload.parentElement.removeChild(preload);
     }})


     let fullWidth = window.innerWidth

     window.addEventListener('resize', function(){

          if(fullWidth !== window.innerWidth){
               window.location.reload();
          }

     }, false)

     $(".form-trigger-btn").on("click", function(){          
          $(".form-small-trigger").click();
     })
      $(".focus-form-btn").on("click", function () {
        $("html, body").animate(
          {
            scrollTop: $("#PresentationsContactForm #pfname").offset().top - 50,
            scrollTop: $("#PresentationsContactForm1 #name1").offset().top - 50,
          },
          1000,
          function () {
            $("#PresentationsContactForm #pfname").focus();
            $("#PresentationsContactForm1 #name1").focus();
          }
        );
      });

}